import React from 'react';
import { Container, Box } from '@mui/material';

export const Layout = (props) => {
  return (
    <Box sx={{ 
      width: '100%', 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Container 
        maxWidth="xl" 
        sx={{ 
          flexGrow: 1,
          px: { xs: 2, sm: 1, md: 4 },
          py: { xs: 2, sm: 3 },
          width: '100%'
        }}
      >
        {props.children}
      </Container>
    </Box>
  );
};
